// extracted by mini-css-extract-plugin
module.exports = {"doneVisitsTable":"doneVisitsTable_doneVisitsTable__4QGVb","doneVisitsTableWithQualification":"doneVisitsTable_doneVisitsTableWithQualification__TBswH"};